import { Component, Input, ViewEncapsulation } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";

import { MatDialog } from "@angular/material/dialog";

import {
  DefaultConfirmationDialogData,
  Dialog,
} from "src/app/models/dialog/dialog.model";
import { BarcodeExtendedDTO, BarcodeTypeDTO } from "src/app/models/Products/productDTO";

import { ConfirmationDialogComponent } from "src/app/shared/modules/dialogs/confirmation-dialog/confirmation-dialog.component";

const BARCODE_FORM_PARAMS = {
  barcodes: "barcodes",
  barcodeTypeCode: "barcodeTypeCode",
  value: "value",
};

@Component({
  selector: "barcodes-list",
  templateUrl: "./barcodes-list.component.html",
  styleUrls: ["./barcodes-list.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class BarcodesListComponent {
  @Input() parentForm: FormGroup;
  @Input() set barcodes(barcodes: BarcodeExtendedDTO[]) {
    if (!barcodes) {
      return;
    }
    this.populateBarcodes(barcodes);
  }
  @Input() barcodeTypes: BarcodeTypeDTO[];
  @Input() duplication: boolean;
  @Input() canWrite: string;

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog
  ) {}

  populateBarcodes(barcodes: BarcodeExtendedDTO[]) {
    const barcodesFormArray = this.getFormArray(BARCODE_FORM_PARAMS.barcodes);
    this.clearFormArray(barcodesFormArray);
    barcodes.forEach((barcode) => {
      const barcodeFormGroup = this.createBarcodeFormGroup(barcode);
      barcodesFormArray.push(barcodeFormGroup);
    });
  }

  getFormArray(formParam: string): FormArray {
    return this.parentForm.get(formParam) as FormArray;
  }

  clearFormArray(formArray: FormArray) {
    formArray.clear();
  }

  createBarcodeFormGroup(barcode?: BarcodeExtendedDTO): FormGroup {
    const {
      barcodeType,
      value,
    } = barcode || {};
    return this.fb.group({
      [BARCODE_FORM_PARAMS.barcodeTypeCode]: [
        barcodeType?.code ?? null,
        [Validators.required],
      ],
      [BARCODE_FORM_PARAMS.value]: [
        value ?? null,
        [Validators.required, Validators.maxLength(20)],
      ],
    });
  }

  addBarcode() {
    const barcodes = this.getFormArray(BARCODE_FORM_PARAMS.barcodes);
    const barcodeFormGroup = this.createBarcodeFormGroup();
    barcodes.push(barcodeFormGroup);
    this.parentForm.markAsDirty();
  }

  openRemoveBarcodeDialog(index: number) {
    const dialogData: Dialog = DefaultConfirmationDialogData;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogData);
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.removeBarcode(index);
      }
    });
  }

  removeBarcode(index: number) {
    const barcodes = this.getFormArray(BARCODE_FORM_PARAMS.barcodes);
    barcodes.removeAt(index);
    if (this.barcodes) {
      this.barcodes = this.barcodes.filter(
        (barcode, barcodeIndex) => barcodeIndex !== index
      );
    }
    this.parentForm.markAsDirty();
  }
}
